import React from 'react';


interface Props {
  onChange: (name: string, value: string) => void,
  name: string,
  description: string,
}


const BkmFormCreateComponent: React.FC<Props> = ({name, description, onChange}) => {
  return (
    <div className='bkm-form create-form'>
      <div className={'bkm-form__1row'}>
        <div className={'bkm-form__textarea'}>
          Name:
          <textarea name='name'
                    placeholder='Bookmark name'
                    value={name}
                    onChange={(e) => onChange('name', e.target.value)}/>
        </div>
        <div className={'bkm-form__textarea'}>
          Description:
          <textarea name='description'
                    placeholder='Bookmark description'
                    value={description}
                    onChange={(e) => onChange('description', e.target.value)}/>
        </div>
      </div>
    </div>
  );
};

export default BkmFormCreateComponent;